import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // Make sure to import navigate if needed

function Login({ onLogin }) {
    const navigate = useNavigate();

    // Initialize formData
    const [formData, setFormData] = useState({ email: '', password: '' });

    // Initialize rememberMe from localStorage so that it persists between refreshes
    const [rememberMe, setRememberMe] = useState(() => {
        return localStorage.getItem('rememberMe') === 'true';
    });

    // On component mount, check if rememberMe is true. If so, load the saved username.
    useEffect(() => {
        if (rememberMe) {
            const savedUsername = localStorage.getItem('username');
            if (savedUsername) {
                setFormData((prev) => ({ ...prev, email: savedUsername }));
            }
        } else {
            // Optionally, clear the email if not remembering.
            setFormData((prev) => ({ ...prev, email: '' }));
        }
    }, [rememberMe]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Update both state and localStorage when the checkbox is toggled
    const handleRememberMeChange = (e) => {
        const isChecked = e.target.checked;
        setRememberMe(isChecked);
        localStorage.setItem('rememberMe', isChecked);
        if (!isChecked) {
            // If unchecked, you might want to clear the saved username from the form (or even localStorage)
            setFormData((prev) => ({ ...prev, email: '' }));
            // Optionally, clear from localStorage:
            // localStorage.removeItem('username');
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/auth/login`,
                formData
            );
            const { token, role } = response.data;

            localStorage.setItem('token', token);
            localStorage.setItem('role', role);

            //console.log('Token saved to localStorage:', token);

            if (onLogin) {
                onLogin(true, role, formData.email); // Pass the email as the username
            }

            // Store or remove the username based on the "Remember Me" checkbox
            if (rememberMe) {
                localStorage.setItem('username', formData.email);
            } else {
                localStorage.removeItem('username');
            }
        } catch (error) {
            console.error('Error logging in:', error);
            if (onLogin) {
                onLogin(false, null);
            }
        }
    };

    // (Optional) Logout function – ensure navigate is available or imported.
    function handleLogout() {
        localStorage.removeItem('token'); // Remove authentication token
        localStorage.removeItem('username'); // Remove saved username
        navigate('/login'); // Redirect to the login page
    }

    return (
        <form onSubmit={handleSubmit} autoComplete="off">
            <input
                type="email"
                name="email"
                placeholder="Email"
                required
                value={formData.email}
                onChange={handleInputChange}
            />
            <input
                type="password"
                name="password"
                placeholder="Пароль"
                required
                value={formData.password}
                onChange={handleInputChange}
            />
            {/* Checkbox for "Remember Me" */}
            <div className="remember-me-container">
                <label>
                    <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={handleRememberMeChange}
                    />
                    {' '}
                    Запомнить меня
                </label>
            </div>
            <button type="submit">Войти</button>
        </form>
    );
}

export default Login;
